import { FC } from "react";
import bg from "../../Assets/homev2/bod-bg.png";
import ContainedButton from "./Buttons/Contained";

const BrandOnDemand: FC = () => {
  return (
    <div
      className="w-full lg:h-full flex flex-col items-center  justify-between gap-4 pt-8 md:pt-20 bg-cover bg-no-repeat bg-bottom px-4 lg:px-0 h-[500px]"
      style={{ backgroundImage: `url('${bg}')` }}
    >
      <div>
        <h2 className="text-2xl md:text-5xl xl:text-7xl text-white font-semibold text-center flex items-start justify-center">
          Branding OnDemand
          <span className="text-xl md:text-3xl font-normal">&#8482;</span>
        </h2>
        <h4 className="text-center text-white text-lg w-[98%] md:mx-0 mx-auto md:text-2xl mt-4">
          Craft your story.<br></br> From logos to web. Stand out.
        </h4>
        <a
          href="https://calendly.com/salesbox-meet/salesmrkt?month=2023-08/"
          className="block mx-auto w-full  max-w-[180px] md:max-w-max py-4 md:mt-10 md:w-max"
        >
          <ContainedButton>Get started</ContainedButton>
        </a>
      </div>
      {/* <div>
        <img src={image} alt="" />
      </div> */}
    </div>
  );
};

export default BrandOnDemand;
